import { AgGridVue } from 'ag-grid-vue'
import { loading, toast } from '@/shared/utils/UIHelper'
import PDRRepository from '@/shared/http/repositories/pci/pdr'
import PDRObraAvaliacaoRepository from '@/shared/http/repositories/pci/pdrobraavaliacao'
import gridMixin from '../mixins/gridMixin'
import CompanyMixin from '@/store/module/company/mixin'
import moment from 'moment'
import PdrGrossValueRenderer from '../components/PdrGrossValueRenderer.vue'

export default {
  name: 'PdrFinalAnalysis',
  mixins: [gridMixin, CompanyMixin],
  components: {
    AgGridVue,
    PdrGrossValueRenderer
  },
  computed: {
    realTerm () {
      return (this.formCheckList.prazoObra || 0) - (this.formCheckList.paralisacoes || 0)
    }
  },
  data () {
    return {
      obrasDataGridOptions: {
        headerHeight: 45,
        rowHeight: 30,
        autoSizeColumns: true
      },
      obrasColumnDefs: [
        {
          headerName: 'Obra',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          showDisabledCheckboxes: true,
          field: 'referencia'
        },
        {
          headerName: 'ID Site',
          field: 'idSite'
        },
        {
          headerName: 'Contrato',
          field: 'referenciaContrato'
        },
        {
          headerName: 'Responsável',
          field: 'responsavelavaliacaofinal'
        },
        {
          headerName: 'Data',
          field: 'terminoanalisefinal',
          type: 'dateColumn'
        },
        {
          headerName: 'Status Avaliação',
          field: 'statuspdr',
          type: 'pdrStatusColumn'
        }
      ],
      membersGridOptions: {},
      membersColumnDefs: [
        {
          headerName: 'Membro',
          menuTabs: [],
          field: 'nome',
          width: 180
        },
        {
          headerName: 'Função',
          menuTabs: [],
          field: 'funcao',
          cellClass: param => {
            return param.data.nome ? '' : 'bold'
          },
          width: 200
        },
        {
          headerName: 'Nota',
          menuTabs: [],
          field: 'nota',
          type: 'numberColumn',
          width: 40
        },
        {
          headerName: 'Bruto',
          menuTabs: [],
          cellRenderer: 'PdrGrossValueRenderer',
          width: 150
        },
        {
          headerName: 'Líquido',
          menuTabs: [],
          field: 'valorLiquido',
          type: 'numberZeroColumn',
          cellClass: param => {
            return param.data.nome ? 'text-right' : 'text-right bold'
          },
          width: 60
        },
        {
          headerName: 'Observações',
          menuTabs: [],
          editable: true,
          field: 'observacoes',
          type: 'memoColumn'
        }
      ],
      editMembersGridOptions: {},
      editMembersColumnDefs: [
        {
          headerName: 'Membro',
          menuTabs: [],
          field: 'nome',
          width: 200
        },
        {
          headerName: 'Função',
          menuTabs: [],
          field: 'funcao',
          cellClass: param => {
            return param.data.nome ? '' : 'bold'
          },
          width: 150
        },
        {
          headerName: 'Nota',
          menuTabs: [],
          field: 'nota',
          type: 'numberColumn',
          width: 40
        },
        {
          headerName: 'Bruto',
          type: 'numberColumn',
          menuTabs: [],
          editable: true,
          valueGetter: (params) => { return params.data.valorBruto },
          valueSetter: (params) => {
            params.data.valorBruto = params.newValue
            params.data.valorLiquido = this.calculateLiquidValue(params)
          },
          width: 50
        },
        {
          headerName: 'Redução 1 (%)',
          type: 'numberColumn',
          menuTabs: [],
          editable: true,
          valueGetter: (params) => { return params.data.reducao1 },
          valueSetter: (params) => {
            params.data.reducao1 = params.newValue
            params.data.valorLiquido = this.calculateLiquidValue(params)
          },
          width: 50
        },
        {
          headerName: 'Redução 2 (%)',
          type: 'numberColumn',
          menuTabs: [],
          editable: true,
          valueGetter: (params) => { return params.data.reducao2 },
          valueSetter: (params) => {
            params.data.reducao2 = params.newValue
            params.data.valorLiquido = this.calculateLiquidValue(params)
          },
          width: 50
        },
        {
          headerName: 'Adicional (%)',
          type: 'numberColumn',
          menuTabs: [],
          editable: true,
          valueGetter: (params) => { return params.data.adicional },
          valueSetter: (params) => {
            params.data.adicional = params.newValue
            params.data.valorLiquido = this.calculateLiquidValue(params)
          },
          width: 50
        },
        {
          headerName: 'Débitos (saldo)',
          type: 'numberColumn',
          menuTabs: [],
          editable: false,
          valueGetter: (params) => { return params.data.saldoDebitos },
          width: 60
        },
        {
          headerName: 'Desconto',
          type: 'numberColumn',
          menuTabs: [],
          editable: (params) => { return params.data.saldoDebitos },
          valueGetter: (params) => { return params.data.desconto },
          valueSetter: (params) => {
            params.data.desconto = params.newValue
            params.data.valorLiquido = this.calculateLiquidValue(params)
          },
          width: 60
        },
        {
          headerName: 'Líquido',
          menuTabs: [],
          field: 'valorLiquido',
          type: 'numberZeroColumn',
          cellClass: param => {
            return param.data.nome ? 'text-right' : 'text-right bold'
          },
          width: 60
        },
        {
          headerName: 'Observações',
          menuTabs: [],
          editable: true,
          field: 'observacoes',
          type: 'memoColumn'
        }
      ],
      obrasRowData: [{}],
      showForm: false,
      formCheckList: null,
      editFormEnabled: false,
      editingCell: null,
      revised: false
    }
  },
  created () {
    this.rowSelection = 'multiple'
    this.isRowSelectable = (params) => {
      return !!params.data && params.data.statuspdr === '9'
    }
  },
  methods: {
    onLoad () {
      this.showForm = false

      loading.push()
      PDRRepository.GetPDRWorks({params: {empresaID: this.company.id, statusPDR: 2}})
        .then(response => {
          if (response.data.data.length) {
            const data = response.data.data[0]

            this.obrasRowData = data.Data
          }
        })
        .catch(error => {
          console.log(error)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    enviarEmail () {
      const lista = this.obrasDataGridOptions.api.getSelectedRows()
      if (lista.length) {
        loading.push()
        PDRObraAvaliacaoRepository.PostEvaluationEmail(lista.map(i => i.id))
          .then(() => {
            this.obrasRowData = this.obrasRowData.filter(row => {
              return lista.indexOf(row) === -1
            })

            toast.success('Email enviado com sucesso')
          })
          .catch(error => {
            console.log(error)
            toast.error(this.$lang.Common.Alerts.Error)
          })
          .finally(() => loading.close())
      }
    },
    viewForm (params) {
      loading.push()
      PDRRepository.GetCheckListBonus(params.node.data.id, {
        params: {
          mostrarMembrosOcultados: false
        }
      })
        .then(response => {
          this.formCheckList = response.data.data

          const mInicio = moment(this.formCheckList.inicioObra).startOf('day')
          const mTermino = moment(this.formCheckList.terminoObra).startOf('day')

          this.formCheckList.inicioObra = mInicio.toDate().toLocaleDateString()
          this.formCheckList.terminoObra = mTermino.toDate().toLocaleDateString()
          this.formCheckList.diasParados = response.data.data.paralisacoes
          this.formCheckList.prazoObra = mTermino.diff(mInicio, 'days') + 1
          this.formCheckList.valorFormatado = this.formCheckList.valor ? this.formCheckList.valor.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}) : null
          // this.revised = params.data.statuspdr === '9'

          const total = {
            funcao: 'TOTAL',
            valorLiquido: this.formCheckList.membros.reduce((acum, obj) => acum + obj.valorLiquido, 0)
          }
          this.formCheckList.membros.push(total)

          this.showForm = true
        })
        .finally(() => loading.close())
    },
    editForm () {
      this.editFormEnabled = true
      this.$nextTick(() => {
        this.editMembersGridOptions.api.sizeColumnsToFit()
      })
    },
    parseForm () {
      loading.push()

      let memberList = this.formCheckList.membros.map(i => {
        return {
          obraMembroID: i.obraMembroID,
          valorBruto: i.valorBruto,
          valorLiquido: i.valorLiquido,
          reducao1: i.reducao1,
          reducao2: i.reducao2,
          adicional: i.adicional,
          desconto: i.desconto,
          observacoes: i.observacoes,
          valorZerado: i.valorZerado
        }
      })

      let idx = memberList.findIndex(m => (m.obraMembroID === undefined || m.obraMembroID === null))
      memberList.splice(idx, 1)

      const membros = memberList

      let valorParsed = this.formCheckList.valor
      if (typeof (this.formCheckList.valor) === 'string') {
        valorParsed = this.formCheckList.valor.replaceAll('.', '').replace(',', '.')
        valorParsed = parseFloat(valorParsed)
      }

      return {
        valor: valorParsed,
        valorFormatado: valorParsed.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}),
        tipoBonificacao: this.formCheckList.tipoBonificacao,
        membros: membros,
        observacao: this.formCheckList.observacao,
        checkAtAntesTermObra: this.formCheckList.checkAtAntesTermObra,
        checkDocComplTerm: this.formCheckList.checkDocComplTerm,
        checkPo: this.formCheckList.checkPo,
        percFat: this.formCheckList.percFat
      }
    },
    approveForm () {
      loading.push()
      PDRRepository.PostCheckListChecked(this.formCheckList.pdrid)
        .then(() => {
          this.onLoad()
        })
        .catch(() => {
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    calculateLiquidValue (params) {
      let liquido = params.data.valorBruto * (params.data.nota / 10)
      liquido -= liquido * params.data.reducao1 / 100
      liquido -= liquido * params.data.reducao2 / 100
      liquido += liquido * params.data.adicional / 100
      liquido -= params.data.desconto
      liquido = parseInt(liquido * 100) / 100
      return liquido
    },
    saveEditForm () {
      let sendForm = this.parseForm()
      PDRRepository.SetCheckListBonusPartial(this.formCheckList.pdrid, sendForm)
        .then((response) => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.editFormEnabled = false
            this.$nextTick(() => {
              this.membersGridOptions.api.refreshCells({force: true})
            })
          } else {
            toast.error(response.data.message)
          }
        })
        .catch(() => {
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    onGridReady (params) {
      this.$nextTick(() => {
        params.api.sizeColumnsToFit()
      })
    },
    onEditGridReady (params) {
      this.$nextTick(() => {
        params.api.sizeColumnsToFit()
      })
    },
    onHide () {
      this.$refs['modal'].hide()
      this.editFormEnabled = false
    }
  },
  beforeMount () {
    this.onLoad()
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/pdrfinalanalysis/pdrfinalanalysis.js